<template>
  <div class="form__wrap">
    <form  class="register">
      <p class="login__register">
        عندك حساب ؟
        <router-link class="router=link" :to="{ name: 'Login' }"
          >قم بتسجيل الدخول</router-link
        >
      </p>
      <h2> قم بأنشاء حسابك في مدونة الرؤي</h2>
      <div class="inputs">
        <div class="input">
          <input type="text" placeholder="الأسم الأول" v-model="firstName" />
          <user class="icon" />
        </div>
        <div class="input">
          <input type="text" placeholder="الأسم الثاني" v-model="lastName" />
          <user class="icon" />
        </div>
        <div class="input">
          <input type="text" placeholder="أسم المستخدم" v-model="userName" />
          <user class="icon" />
        </div>
        <div class="input">
          <input type="text" placeholder="البريد الألكتروني" v-model="email" />
          <email class="icon" />
        </div>
        <div class="input">
          <input type="password" placeholder="كلمة المرور" v-model="password" />
          <password class="icon" />
        </div>
        <div v-show="error" class="error">{{ this.errorMsg }}</div>
      </div>
      <button @click.prevent="register">انشاء الحساب</button>
      <div class="angle"></div>
    </form>
    <div class="background"></div>
  </div>
</template>

<script>
import email from "../assets/Icons/envelope-regular.svg";
import password from "../assets/Icons/lock-alt-solid.svg";
import user from "../assets/Icons/user-alt-light.svg";
import firebase from "firebase/app";
import "firebase/auth";
import db from "../firebase/firebaseInit";
export default {
  name: "Register",
  components: {
    email,
    password,
    user,
  },
  data() {
    return {
      firstName: "",
      lastName:  "",
      userName:  "",
      email:     "",
      password:  "",
      error:     "",
      errorMsg:  "",
    };
  },
  methods: {
    async register() {
      if (
        this.email !== "" &&
        this.password !== "" &&
        this.firstName !== "" &&
        this.lastName !== "" &&
        this.userName !== ""
      ) {
        this.error = false;
        this.errorMsg =""
        const firebaseAuth = await firebase.auth();
        const createUser   = await firebaseAuth.createUserWithEmailAndPassword(this.email, this.password)
        const result = await createUser;
        const dataBase = db.collection("users").doc(result.user.uid)

        await dataBase.set({
          firstName:this.firstName,
          lastName:this.lastName,
          userName:this.userName,
          email:this.email,
        })
        this.$router.push ({name:"Home"})
        return;
      } else {
        this.error = true;
        this.errorMsg = "نرجو ملئ جميع الخانات";
        return;
      }
    },
  },
};
</script>

<style lang="scss">
.register {
  h2 {
    max-width: 350px;
  }
}
</style>
